import React, {useRef} from "react";
import {ARModalForm} from "../ARModalForm";
import {showModalWindow} from "../../../utils/actionWrappers";

const useFormModal = (submitCallback) => {
  const successfulSubmitSubscriber = useRef();

  const subscribeToSuccessfulSubmit = (callback) => {
    successfulSubmitSubscriber.current = callback;
  };

  const formSubmit = (formData) => {
    submitCallback(formData);
    typeof successfulSubmitSubscriber.current === "function" && successfulSubmitSubscriber.current();
  };

  return ({title, formId, fields, formClassName = "", validationSchema, defaultValues}) => {
    showModalWindow.form({
      title,
      message:
        <ARModalForm
          formId={formId}
          className={formClassName}
          onFormSubmit={formSubmit}
          defaultValues={defaultValues}
          validationSchema={validationSchema}
        >
          {fields}
        </ARModalForm>,
      formOptions: {
        formId,
        subscribeToSuccessfulSubmit
      }
    });
  };
};

export default useFormModal;